import React, { useState } from 'react';

function CommentReply({
  image,
  errorImage,
  handleSubmitReply,
  setReplies
}) {
  const [replyContent, setReplyContent] = useState('');

  return (
    <div className="reply-box position-relative overflow-hidden">
      <div className="avatar">
        <img
          src={image}
          className="profileicon"
          href="javascript:void(0);"
          alt="proimg"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = errorImage;
          }}
        />
      </div>
      <div className="reply-input">
        <textarea 
          placeholder="Write a reply..."
          rows="2"
          onChange={(e) => setReplyContent(e.target.value)}
        ></textarea>
        <button
          type="button"
          onClick={() => handleSubmitReply(replyContent)}
          className="submit-reply-button"
        >Post Reply</button>
      </div>

      <div className="reply-close position-absolute end-0 top-0">
        <button className='btn text-white bg-danger' onClick={() => setReplies(false)}><i className="fa fa-times" aria-hidden="true"></i></button>
      </div>
    </div>
  )
}


export default CommentReply;